/**
 * WEB VIEW MANAGER const symbols.
 * @constant
 * @type {Object}
 */
const WEB_VIEW_TYPES = {
    MASTER: 0,
    SECOND: 1,
    SAFARI: 2
};

const WEB_VIEW_IDS = {
    MASTER_ID: 0,
    GAME_ID: 1,
    SAFARI_ID: 1000,
    DEPOSIT_WIDGET_ID: 1100
};

const WIDGET_TYPES = {
    DEPOSIT: 0,
    MIT_ID: 1,
    SPID: 2,
    GAME:3
};

const WEB_VIEW_REASON = {
    UN_DEFINED: -1,
    WEB_SECOND_NOT_SUPPORTED: 400,
    CLOSE_BUT_CLICKED: 500,
    CLOSE_BY_WEB: 501,
    CLIENT_TAPED_ON_VIEW: 600,
    OPEN_LINK: 700
};

const DEVICE_SHIFTS = {
    IPHONE_DEFAULT: 82,
    IPHONE_X_PORTRATE: 15,
    IPHONE_X_LANDSCAPE: 10,
    IPHONE_X_12_PRO_LANDSCAPE: 25,
    ANDROID_X_BUTL: 35,
    ANDROID_DEFAULT: 0,
    ANDROID_S9_WIDTH: 360,
    ANDROID_S9_HEIGHT: 740,
    ANDROID_S9_DENSITY_2 : '2.0',
    ANDROID_S9_DENSITY_4 : '4.0',
    ANDROID_S9_DP_2: 14,
    ANDROID_S9_DP_4: -16,
    ANDROID_S9_LANDSCAPE: -2,
    ANDROID_PORTRATE_NAV_BAR_DISPLAY: 18,
    ANDROID_PORTRATE_NAV_BAR_NOT_DISPLAY: 115
};

const WINDOW_ELEMENTS = {
    SPORT: 'isSIC'
};

const WEB_VIEW_INFO = {
    TYPE: 'type',
    ACTION: 'action',
    ENAABLE_SNAP_SHOT: 'enableSnapShot',
    INJECT_FUNC: 'injectfunc',
    DEL_INJECT: '@@@',
    FRAME_OFFSET_TOP_Y: 'frameOffsetTopY',
    FRAME_OFFSET_TOP_PORTRATE_Y: 'topPortrateY',
    FRAME_TOP_LANDSCAPE_Y: 'frameOffsetTopLandscapeY',
    FRAME_TOP_PORTRATE_Y: 'frameOffsetTopPortrateY',
    FRAME_TOP_PORTRATE_IPHONE_X: 'frameOffsetTopPortrateIphoneX',
    FRAME_OFFSET_BOTTOM_Y: 'frameOffsetBottomY',
    ID: 'webid',
    URL: 'url',
    DISPLAY_GAME_TIME_OUT: 'displayGameTimeOut',
    TAP_KEEP_ALIVE: 'tapKeepAlive',
    BUT_INIT: 'butInit', // Close button
    BUT_RTL: 'butRTL',
    BUT_W: 'butW',
    BUT_H: 'butH',
    BUT_X: 'butX',
    BUT_Y: 'butY',
    DP_TO_PX: 'dp2px',
    BUT_LANDSCARE_X: 'butlandscapeX',
    BUT_LANDSCARE_Y: 'butlandscapeY',
    CLOSE_BUT_CLICKED: 'closebutclicked',
    WEB_SECOND_NOT_SUPPORTED: 'websecondnotsupported',
    CLOSE_CALLED_BY_WEB: 'closesafari',
    TAP_ON_VIEW: 'tapAction',
    ORIENTATION: 'orientation',
    REMOTE_URL: 'remoteurl',
    WINDOW_ELEMENT: 'windowelement',
    SHIFT_FROM_BOTTOM: 'shiftFromBottom',
    IPHONE_X_PORTRATE: 'iphonexportrate',
    IPHONE_X_LANDSCAPE: 'iphonexlandscape',
    ANDROID_PORTRATE: 'androidportrate',
    ANDROID_LANDSCAPE: 'androidlandscape',
    IPHONE_X_12_PRO_LANDSCAPE: 'iphonex12prolandscape',
    ANDROID_PORTRATE_NAV_BAR_DISPLAY: 'androidportratenavbardisplay',
    ANDROID_PORTRATE_NAV_BAR_NOT_DISPLAY: 'androidportratenavbarnotdisplay'
};

const WEB_INJECT_FUNC = {
    DRAG_STARTED: 'function dragStarted(x,y) {var el = document.elementFromPoint(x, y);var evt = new MouseEvent(\'click\', {bubbles: true,cancelable: true,view: window, screenX: x, screenY: y, clientX: x+10, clientY: y + 10});el.dispatchEvent(evt);}',
    DEBUG_FUNC: 'function onclock() {var devtools = /./; devtools.toString = function() { webkit.messageHandlers.cbCallBackHandlerCGP.postMessage(\'isdebugenable\'); }; console.log(\'%c\', devtools);} setInterval(onclock, 200);',
    PIXEL_EL: 'var elemDiv = document.createElement(\'div\'); elemDiv.style.cssText = \'position:fixed;width:1px;height:1px;z-index:99999;background:black;\';document.body.appendChild(elemDiv);',
    READY: 'setTimeout(function() {webkit.messageHandlers.cbCallBackHandlerCGP.postMessage(\'onready\');}, 100);'
};


export {WEB_VIEW_TYPES, WEB_VIEW_IDS, WEB_VIEW_INFO, WEB_VIEW_REASON,DEVICE_SHIFTS, WEB_INJECT_FUNC, WINDOW_ELEMENTS, WIDGET_TYPES};